module.exports = __webpack_public_path__ + "src/assets/img/light_turn_r.37a55ad5.svg";